/**
 * 增加的路由地址记得加到这里，不然titlebar就不能高亮了
 */

export const routeMenuChilds = [{
    path: '/my-workspace',
    children: [
      '/my-workspace',
      '/my-workbench/MyWorkbench'
    ]
  },
  {
    path: '/record-manage',
    children: [
      '/record-manage',
      '/report-manage/daily',
    ]
  },
  {
    path: '/order-manage',
    children: [
      '/order-manage'
    ]
  },
  {
    path: '/meeting-record',
    children: [
      '/meeting-record',
      '/meeting-manage/CreatingMeeting'
    ]
  },
  {
    path: '/project-manage',
    children: [
      '/project-manage',
      '/project-manage/version/list',
      '/project-manage/new-start/NewStart',
      '/project-manage/report-manage/list',
      '/project-manage/overtime-manage/list',
      '/project-manage-b/ProjectInformation',
      '/project-manage-b/DemandManage',
      '/project-manage/projectMember-manage/list',
      '/project-manage/projectMember-manage/roleAuthority',
      '/project-manage/projectContact',
      '/project-manage/projectMember-manage/projectDataBoard',
      '/project-manage-b/DemandDetail',
      '/project-manage-b/ChangeManage',
      '/project-manage-b/ChangeManageList',
      '/project-manage-b/RDMilestone',
      '/project-manage-b/RiskManagement',
      '/project-manage-b/ProgressEstimate',
      '/project-manage-b/DocumentManagement',
      '/project-manage-b/stageSummary',
      '/project-manage/report-manage/weekly',
      '/project-manage/report-manage/newWeekly',
    ]
  },
  {
    path: '/orgtree',
    children: [
      '/orgtree',
      '/system-manage/organizational-structure/add'
    ]
  },
  {
    path: '/data-ship',
    children: [
      '/data-ship',
      '/data-ship-a',
      '/data-ship-b',
      '/data-ship-c',
      '/data-cockpit/AttendanceRecord'
    ]
  },
  {
    path: '/superadmin',
    children: [
      '/superadmin',
      '/system-manage/companyInfo',
      '/system-manage/functionalAuthority',
      '/system-manage/dict/list',
      '/system-manage/other-service/list',
      '/system-manage/other-authorization/index',
      '/system-manage/admin-authorization/index',
      '/system-manage/weeklyMailManage',
      '/system-manage/systemJournal/index',
      '/system-manage/fullCalendar/index',
    ]
  }
];



// WEBPACK FOOTER //
// ./src/views/layout/components/activeMenu.js